import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, Subject, takeUntil } from 'rxjs';
import { ConsoleLogger } from '../shared/console-logger';
import PopupState from '../enums/popup.state.enum';

@Injectable({ providedIn: 'root' })
export class ClientLoginService {
  private popupWindow: any;
  private ww = 520;
  private wh = 650;
  private wtop = ((document.body.clientHeight - this.wh) / 2) + window.screenTop;
  private wleft = ((document.body.clientWidth - this.ww) / 2) + window.screenLeft;
  private pos = 'top=' + this.wtop + ',left=' + this.wleft + ',width=' + this.ww +
    ',height=' + this.wh +
    'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no';
  private _popupState: BehaviorSubject<PopupState> = new BehaviorSubject<PopupState>(undefined);
  private popupState$: Observable<PopupState> = this._popupState.asObservable();
  private _isPopupClosedTimer: Subject<boolean> = undefined;

  constructor() {
  }

  public open(url: string, state: PopupState) {
    if (!this.popupWindow) {
      ConsoleLogger.debug('popupWindow open url=' + url);
      this.popupWindow = window.open(url, 'login', this.pos);
      this.setPopupState(state);
      this._isPopupClosedTimer = new Subject<boolean>();

      interval(3000)
        .pipe( takeUntil(this._isPopupClosedTimer) )
        .subscribe(() => {
          if (this.popupWindow?.closed) {
            this.close();
          }
        });
    }
  }

  public close() {
    if (this._isPopupClosedTimer) {
      this._isPopupClosedTimer.next(true);
      this._isPopupClosedTimer.complete();
      this._isPopupClosedTimer = undefined;
    }


    if (this.popupWindow) {
      this.setPopupState(PopupState.CLOSED);
      this.popupWindow.close();
      this.popupWindow = undefined;
    }
  }

  public setFocus() {
    if(this.popupWindow) {
      this.popupWindow.focus();
    }
  }

  public getPopupState$(): Observable<PopupState> {
    return this.popupState$;
  }

  public setPopupState(value: PopupState) {
    this._popupState.next(value);
  }
}
